<template>
<!-- 轮播图配置 -->
  <div id="carouselList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="fieldsList" :needReturn="'id'" :placeholder="'请选择领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="searchData.fieldId">
              </allSelect>
            </abbr>
          </p>
          <p>
            <abbr class="d_i">
              <allSelect :chooseData="indicationsList" :needReturn="'id'" :placeholder="'请选择适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="searchData.indicationId">
              </allSelect>
            </abbr>
          </p>
          <button class="redButton" @click="getList(1)">搜索</button>
        </div>
        <div style="width: auto">
          <button class="redButtonTwo" @click="newCarousel">新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable" style="table-layout: fixed;">
          <thead>
            <tr>
              <th>轮播图名称</th>
              <th>领域</th>
              <th>适应症</th>
              <th>创建时间</th>
              <th>更新时间</th>
              <th>是否置顶</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="myList.length >0">
              <tr :key="index" v-for="(item, index) in myList">
                <td width="20%" class="NoWrap" :title="item.name">{{item.name}}</td>
                <td width="20%" class="NoWrap" style="max-width: 250px" :title="item.fieldNames">{{item.fieldNames}}</td>
                <td width="20%" class="NoWrap" :title="item.indicationNames">{{item.indicationNames}}</td>
                <td width="15%">{{item.createTime ? $commonJs.returnNewDate(item.createTime) : ''}}</td>
                <td width="15%">{{item.updateTime ? $commonJs.returnNewDate(item.updateTime) : ''}}</td>
                <td width="5%">{{item.showOrder == '-1' ? '是' : '否'}}</td>
                <td width="5%"><div class="icon more iconfont icongengduo moreOperations">
                  <ul>
                    <!-- <li @click="viewListItem(item)">查看</li> -->
                    <li @click="editListItem(item)">编辑</li>
                    <li @click="deleteDraftItem(item)">删除</li>
                  </ul>
                </div></td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="7">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="searchData.PageIndex" :explain="0"></page>
    </div>
    <!-- 新增轮播图 -->
    <model v-if="showModel" :buttonType="0" :title="modelTitle" :minWidth="'800px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div style="width:70%; margin: 10px auto;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>名称</span>
            <input v-if="modelType != 'view'" maxlength="50" v-model="modelData.name" type="text" class="allInput" style="width: calc(100% - 110px);max-width: 340px;margin-left: -37px;" placeholder="请输入名称" />
            <span v-else style="width: calc(100% - 110px);margin-left: -37px;">{{modelData.name}}</span>
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>领域</span>
            <span v-if="modelType != 'view'" style="width: calc(100% - 110px); margin-left: -37px;">
              <allSelect :multiple="true" :width="350" v-on:on-change="changeField" :chooseData="fieldsListNew" :needReturn="'id'" :placeholder="'请选择领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.fieldId">
              </allSelect>
            </span>
            <span v-else style="width: calc(100% - 110px);margin-left: -37px;">{{modelData.name}}</span>
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>适应症</span>
            <span v-if="modelType != 'view'" style="width: calc(100% - 110px); margin-left: -37px;">
              <allSelect :multiple="true" :width="350" :chooseData="indicationsListNew" :needReturn="'id'" :placeholder="'请选择适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="modelData.indicationId">
              </allSelect>
            </span>
            <span v-else style="width: calc(100% - 110px);margin-left: -37px;">{{modelData.name}}</span>
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>封面</span>
            <span v-if="modelType != 'view'" style="width: 282px; margin-left: -37px;">
              <div style="text-align: center">
                <input @change="clopuploadImg($event)" type="file" id="inFile" class="coverFile" accept="image/*"/>
                <label style="width: 282px;height:auto;min-height:120px;" for="inFile">
                  <!-- width="282" height="120" -->
                  <div v-if="modelData.picturePath"><img :src="baseUrl + '/api/RotationChart/GetFile?filepath=' + encodeURIComponent(modelData.picturePath)" style="border-radius: 8px;width:100%;height:100%;"/></div>
                  <div v-else style="margin-top: 20px">
                    <i class="icon iconfont iconshangchuan1 colorDH" style="font-size: 50px"></i>
                    <p v-if="CNmode" class="m_t_10 colorGray">点击上传封面图片</p>
                    <p v-else class="m_t_10 colorGray">Cover Picture</p>
                  </div>
                </label>
                <div v-if="CNmode">
                  <span class="colorGray">请上传900*500比例的图片</span>
                </div>
                <div v-else>
                  <span class="colorGray">Recommended size: 900*500</span>
                </div>
              </div>
            </span>
            <span v-else style="width: calc(100% - 110px);margin-left: -37px;">
              <!-- width="282" height="120" -->
              <div style="width: 282px;height:auto;min-height:120px;"><img :src="baseUrl + '/api/RotationChart/GetFile?filepath=' + encodeURIComponent(modelData.picturePath)" style="border-radius: 8px;width:100%;height:100%;"/></div>
            </span>
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>地址</span>
            <input v-if="modelType != 'view'" v-model="modelData.jumpLink" type="text" class="allInput" style="width: calc(100% - 110px);max-width: 340px;margin-left: -37px;" placeholder="请输入地址" />
            <span v-else style="width: calc(100% - 110px);margin-left: -37px;">{{modelData.jumpLink}}</span>
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>是否置顶</span>
            <span style="width: calc(100% - 110px);max-width: 340px;margin-left: -37px;">
              <input :disabled="modelType == 'view'" v-model="modelData.showOrder" id="isOnTop" class="allSwitch" type="checkbox" >
              <label for="isOnTop"></label>
            </span>
          </li>
        </ul>
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'carouselList',
  data () {
    return {
      CNmode: true,
      baseUrl: process.env.config.baseUrl,
      token: window.sessionStorage.getItem('token'),token: window.sessionStorage.getItem('token'),
      totalPage: 1,
      totalCount: 0,
      page: 1,
      searchData: {
        name: '',
        fieldId: '',
        indicationId: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      modelTitle: '',
      modelType: '',
      showModel: false,
      modelData: {
        id: 0,
        name: '',
        fieldId: '',
        indicationId: '',
        picturePath: '',
        jumpLink: '',
        showOrder: false
      },
      fieldsList: [],
      fieldsListNew: [],
      indicationsList: [],
      indicationsListNew: []
    }
  },
  created () {
    // 获取轮播图列表
    this.getList()
    // 获取领域
    this.getFieldsList()
    // 获取适应症
    this.getIndicationsList()
  },
  methods: {
    // 获取轮播图列表
    getList (page = 1) {
      this.searchData.PageIndex = page
      let params = {
        name: '',
        fieldId: this.searchData.fieldId ? [Number(this.searchData.fieldId)] : [],
        indicationId: this.searchData.indicationId ? [Number(this.searchData.indicationId)] : [],
        paged: {
          pageIndex: this.searchData.PageIndex,
          pageSize: this.searchData.PageSize
        }
      }
      this.$axiox.post(`/api/RotationChart/Query`, params).then(res => {
        console.log(res, 'getList')
        if (res.data) {
          this.myList = res.data.map(val => {
            return {
              fieldNames: val.fields.map(val => val.name).join(','),
              indicationNames: val.indications.map(val => val.name).join(','),
              ...val
            }
          })
          console.log(this.myList, 'getList')
          this.totalPage = Math.ceil(res.total / this.searchData.PageSize)
          this.totalCount = res.total
        } else {
          this.myList = []
          this.totalPage = 0
          this.totalCount = 0
        }
      })
    },
    // 查看轮播图
    viewListItem (item) {
      console.log(item, 'viewListItem---item')
      this.modelTitle = '查看轮播图'
      this.modelType = 'view'
      this.getCarouselItemById(item.id)
      this.showModel = true
    },
    getCarouselItemById (id) {
      this.$axiox.get(`/api/RotationChart/GetRotationChart/${id}`).then(res => {
        console.log(res, 'getCarouselItemById---res')
        this.modelData = {
          id: res.id,
          name: res.name,
          fieldId: res.fieldId.join(','),
          indicationId: res.indicationId.join(','),
          picturePath: res.picturePath,
          jumpLink: res.jumpLink,
          showOrder: res.showOrder == -1 ? true : false
        }
        console.log(this.modelData, 'this.modelData')
      })
    },
    // 编辑轮播图
    editListItem (item) {
      this.modelTitle = '编辑轮播图'
      this.modelType = 'edit'
      this.getCarouselItemById(item.id)
      this.showModel = true
      console.log(item, 'editListItem')
    },
    // 删除轮播图
    deleteDraftItem (item) {
      console.log(item, 'deleteDraftItem')
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此轮播图？',
        successFun: msg => {
          this.$axiox.del('/api/RotationChart/DeleteRotationChart/' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            // 获取轮播图列表
            this.getList(1)
          })
        },
        errorFun: msg => {
        }
      })
    },
    // 新建轮播图
    newCarousel () {
      this.modelTitle = '新建轮播图'
      this.modelType = 'new'
      this.showModel = true
    },
    confirModel () {
      console.log(this.modelData, 'this.modelData')
      this.modelData.name = this.modelData.name.trim()
      if (this.modelData.name === '' || this.modelData.fieldId === '' || this.modelData.indicationId === '' || this.modelData.picturePath === '' || this.modelData.jumpLink === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请检查必填项',
          stayTime: 5
        })
        return
      }
      // let reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/
      // if (!reg.test(this.modelData.jumpLink)) {
      //   this.$commonJs.alertTips({
      //     type: 'error',
      //     title: '失败',
      //     content: '请输入正确的地址',
      //     stayTime: 5
      //   })
      //   return
      // }
      if (this.modelData.jumpLink !== '' && this.modelData.jumpLink.indexOf('http') !== 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请输入正确的地址',
          stayTime: 5
        })
        return
      }
      if (this.modelType == 'new') {
        // let params = JSON.parse(JSON.stringify(this.modelData))
        // params.fieldId = Number(params.fieldId)
        // params.indicationId = Number(params.indicationId)
        // params.showOrder = this.modelData.showOrder ?  -1 : 0
        let params = {
          name: this.modelData.name,
          fieldId: this.modelData.fieldId.split(',').map(val => Number(val)),
          indicationId: this.modelData.indicationId.split(',').map(val => Number(val)),
          picturePath: this.modelData.picturePath,
          jumpLink: this.modelData.jumpLink,
          showOrder: this.modelData.showOrder ? -1 : 0
        }
        console.log(params, 'confirModel---params')
        this.$axiox.post(`/api/RotationChart/AddRotationChart`, params).then(res => {
          console.log(res, 'confirModel----res')
          // 获取轮播图列表
          this.getList(1)
          this.showModel = false
        })
      } else if (this.modelType == 'edit') {
        // let params = JSON.parse(JSON.stringify(this.modelData))
        // params.fieldId = Number(params.fieldId)
        // params.indicationId = Number(params.indicationId)
        // params.showOrder = this.modelData.showOrder ?  -1 : 0
        let params = {
          id: this.modelData.id,
          name: this.modelData.name,
          fieldId: this.modelData.fieldId.split(',').map(val => Number(val)),
          indicationId: this.modelData.indicationId.split(',').map(val => Number(val)),
          picturePath: this.modelData.picturePath,
          jumpLink: this.modelData.jumpLink,
          showOrder: this.modelData.showOrder ? -1 : 0
        }
        console.log(params, 'confirModel---params')
        this.$axiox.put(`/api/RotationChart/UpdateRotationChart`, params).then(res => {
          console.log(res, 'confirModel----res')
          // 获取轮播图列表
          this.getList(1)
          this.showModel = false
        })
      }

    },
    cancelModel () {
      this.showModel = false
    },
    clopuploadImg (e) {
      console.log(e, 'clopuploadImg')
      // 上传图片
      var file = e.target.files[0]
      this.signalUpload(file)
      e.target.value = '' // 防止第二次上传相同的文件不执行
    },
    async signalUpload (e) {
      console.log(e, 'signalUpload')
      let fileImg = e
      if (fileImg.type.indexOf('image') >= 0) {
        if (fileImg.type.indexOf('png') >= 0 || fileImg.type.indexOf('jpeg') >= 0 || fileImg.type.indexOf('jpg') >= 0) {
          let imgSize = ((fileImg.size / 1024) / 1024).toFixed(2)
          if (imgSize < 10) {
            this.modelData.picturePath = await this.$commonJs.uploadFile(fileImg, '/api/RotationChart/addThumb')
            console.log(this.modelData.picturePath, 'this.modelData.picturePath')
            document.getElementById('inFile').value = ''
          } else {
            this.$commonJs.alertTips({
              type: 'error',
              title: '错误',
              content: '只允许上传10M以内图片',
              stayTime: 5
            })
          }
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '错误',
            content: '只允许上传*.jpg / *.png格式',
            stayTime: 5
          })
        }
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '只允许上传图片',
          stayTime: 5
        })
      }
    },
    // 获取领域
    getFieldsList () {
      this.$axiox.get(`/api/Dict/GetFields`).then(res => {
        console.log(res, 'getFieldsList')
        this.fieldsListNew = JSON.parse(JSON.stringify(res))
        this.fieldsList = [
          {
            id: 0,
            name: '全部',
          },
          ...res
        ]
      })
    },
    // 获取适应症
    getIndicationsList (ids = []) {
      console.log(ids, 'ids-------99999999999')
      let params = ids
      this.$axiox.post(`/api/Dict/GetIndications`, params).then(res => {
        console.log(res, 'getIndicationsList')
        this.indicationsListNew = JSON.parse(JSON.stringify(res))
        this.indicationsList = [
          {
            id: 0,
            fieldId: '',
            name: '全部',
          },
          ...res
        ]
      })
    },
    changeField () {
      console.log(this.modelData.fieldId, 'this.modelData.fieldId')
      this.modelData.indicationId = ''
    }

  },
  watch: {
    showModel (newData) {
      if (!newData) {
        this.modelData = {
          id: 0,
          name: '',
          fieldId: '',
          indicationId: '',
          picturePath: '',
          jumpLink: '',
          showOrder: false
        }
      }
    },
    "searchData.fieldId" (newData) {
      console.log(newData, 'searchData.fieldId')
      this.searchData.indicationId = ''
      let ids = [newData]
      if (!newData) {
        ids = []
      } else {
        ids = [newData]
      }
      console.log(ids, 'ids')
      // 获取适应症
      this.getIndicationsList(ids)
    },
    "modelData.fieldId" (newData) {
      console.log(newData, 'modelData.fieldId')
      // let ids = [newData]
      // if (!newData) {
      //   ids = []
      // } else {
      //   ids = [newData]
      // }
      // console.log(ids, 'ids')
      let ids = []
      if (newData) {
        ids = newData.split(',').map(val => Number(val))
        console.log(ids, 'ids')
      }
      // 获取适应症
      this.getIndicationsList(ids)
    },
    "modelData.showOrder" (newData) {
      console.log(newData, 'modelData.showOrder')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/videoManager/carouselList.vue